import { Table } from "melco-ui";
import { useAddRemoveMachines } from "../../hooks/hoops/useAddRemoveMachines";
import { useMemo } from "react";
import { ControlcenterMelcoModelsSupplierProduct } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

export type HoopMachinesListProps = {

}



type Props = {
    allMachines: ControlcenterMelcoModelsSupplierProduct[];
    selectedPlatformIds: string[];
};

export const HoopMachinesList: React.FC<Props> = ({
    allMachines,
    selectedPlatformIds
}) => {
    const { machines, addMachines, removeMachines } = useAddRemoveMachines();

    const { t } = useTranslation();

    const filtered = useMemo(() => {
        // useMemo is used to memoize the filtered result
        // WHY: avoids recalculating on every render unless dependencies change
        // Improves performance when allMachines is large

        return allMachines.filter(
            (m): m is typeof m & { platform_id: string } =>
                // This is a TYPE GUARD
                // WHAT: tells TypeScript that if this condition passes,
                //       then "m.platform_id" is definitely a string
                // WHY: without this, TS thinks platform_id could be null/undefined

                typeof m.platform_id === "string" &&
                // WHAT: runtime check to ensure platform_id is actually a string
                // WHY: protects against null / undefined values from API

                selectedPlatformIds.includes(m.platform_id)
            // WHAT: checks if this machine belongs to a selected platform
            // WHY: we only want machines linked to selected platforms
        );
    }, [allMachines, selectedPlatformIds]);
    // WHAT: dependencies array for useMemo
    // WHY: recompute only when machine list OR selected platforms change

    const selectedRowKeys = machines.map((m) => m.id);

    const rowSelection = {
        selectedRowKeys,
        onChange: (keys: React.Key[]) => {
            const newIds = keys as string[];

            const added = filtered.filter(
                (m) =>
                    newIds.includes(m.id) &&
                    !selectedRowKeys.includes(m.id)
            );

            const removed = selectedRowKeys.filter(
                (id) => !newIds.includes(id)
            );

            if (added.length) addMachines(added);
            if (removed.length) removeMachines(removed);
        }
    };

    return (
        <Table
            rowKey="id"
            dataSource={filtered}
            columns={[
                {
                    title: t("managehoops.tabs.machines.table.machines.columns.name"),
                    dataIndex: "name"
                }
            ]}
            rowSelection={rowSelection}
            pagination={{ pageSize: 10 }}
        />
    );
};
